import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import {
  getCampaignDiscountBadge,
  getCampaignFundedByLabel,
  getCampaignOfferLabel,
  isInternalCampaign
} from '@/ducks/campaigns/campaigns.helpers'
import type { Campaign } from '@/ducks/campaigns/campaigns.types'
import { selectCurrencySymbol } from '@/ducks/store/selectors/store.selectors'

import Styles from './CampaignsTable.module.scss'

type Props = {
  campaign: Campaign
}

const CampaignOfferCell = ({ campaign }: Props) => {
  const { t } = useTranslation()
  const currency = useSelector(selectCurrencySymbol) || ''
  const discountBadge = getCampaignDiscountBadge(campaign, t, currency)

  return (
    <div className={Styles.offerContent}>
      <div className={Styles.offerTitleRow}>
        <span className={Styles.offerTitle}>
          {getCampaignOfferLabel(campaign, t)}
        </span>
        {discountBadge && (
          <span className={Styles.percentBadge}>{discountBadge}</span>
        )}
      </div>
      {isInternalCampaign(campaign) ? (
        <span className={Styles.yassirBadge} data-testid="campaign-by-yassir">
          {t('marketing.campaigns.by-yassir')}
        </span>
      ) : (
        <span className={Styles.offerSubtitle}>
          {getCampaignFundedByLabel(campaign, t)}
        </span>
      )}
    </div>
  )
}

export default CampaignOfferCell
